// modules/authentication/router/auth-guard.js
import { useAuthLoginStore } from 'modules/authentication/stores/auth-login-store'

const isAuthenticatedGuard = async (to, from, next) => {
  const authLoginStore = useAuthLoginStore()

  // ✅ si el store ya tiene status authenticated (seteado por SSO), dejar pasar sin introspect
  if (authLoginStore.currentStatus === 'authenticated') {
    return next()
  }

  const { ok } = await authLoginStore.checkAuthentication()

  if (ok) next()
  else next({ name: 'authHome' })
}

export default isAuthenticatedGuard